import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import all pages
import {
  PagePublic,
  PageSetNewPassword,
  PageDashboard,
  PageSystemIntegratorMaster,
  PageProjectDetails,
  PageAiDashboard,
  PageD2H,
  PageAddChannel,
  PageEditChannel,
  PageDeleteChannel,
  PageAddNewChannel,
  PageMusic,
  PageMusicPushData,
  PageMovies,
  PageMoviesPushData,
  PageAllDevices,
  PageMisc,
  PagePushData,
  PageD2HShowsAi,
  PageD2HShowsAiPushData,
  PageOkasBoxes,
  PageAssignOkasboxes,
  PageInternalVersion,
  PageSupport,
  PageTicketSupport,
  PageWarrantyOkasBox,
  PagePublicVersion,
  PageD2HList,
  PagePageNotFound,
  PageMemberLicense,
  PageAssignMemberLicense,
  PageDistributor,
  PageKnowledge,
  PageVideo,
  PageUpcomingEvents,
  PageWhatsNew,
  PageSubscriptions,
  PageMarketSpace,
  PageMarketSpaceForm,
  PageMarketSpaceFormEdit,
  PageMarketSpaceDownload,
  PageSubscriptionsPlan,
  PageOkasAdditionalInventoryRequest,
  PageSupportRemoteAccess,
  PageDesignStudioRemoteAccess,
  PageRole,
  PageUser,
  PageOta,
  PageOtaBeta,
  PageOtaCrashLogsList
} from "./../containers/Pages";

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/" element={<PagePublic />} />
      <Route path="/session-timeout" element={<PagePublic />} />
      <Route path="/login/activateuser/:id" element={<PageSetNewPassword />} />
      <Route path="/dashboard" element={<PageDashboard />} />
      <Route
        path="/systemintegrator/system"
        element={<PageSystemIntegratorMaster />}
      />
      <Route path="/masterdevice/alldevice" element={<PageAllDevices />} />
      <Route
        path="/systemintegrator/projectdetails"
        element={<PageProjectDetails />}
      />
      <Route path="/ai/dashboard" element={<PageAiDashboard />} />
      <Route path="/ai/d2h" element={<PageD2H />} />
      <Route path="/ai/d2hlist" element={<PageD2HList />} />
      <Route path="/ai/editchannel/" element={<PageEditChannel />} />
      <Route path="/ai/deletechannel/" element={<PageDeleteChannel />} />
      <Route path="/ai/addchannel/" element={<PageAddChannel />} />
      <Route path="/ai/addnewchannel" element={<PageAddNewChannel />} />
      <Route path="/ai/pushdata" element={<PagePushData />} />
      <Route path="/ai/showsai" element={<PageD2HShowsAi />} />
      <Route path="/ai/showsaipush" element={<PageD2HShowsAiPushData />} />
      <Route path="/ai/misc" element={<PageMisc />} />
      <Route path="/ai/movies" element={<PageMovies />} />
      <Route path="/ai/moviespushdata" element={<PageMoviesPushData />} />
      <Route path="/ai/music" element={<PageMusic />} />
      <Route path="/ai/musicpushdata" element={<PageMusicPushData />} />
      <Route path="/okasboxes/dashboard" element={<PageOkasBoxes />} />
      <Route path="/okasboxes/assignboxes" element={<PageAssignOkasboxes />} />
      <Route
        path="/okasboxes/warrantystatus"
        element={<PageWarrantyOkasBox />}
      />
      <Route path="/memberlicense/dashboard" element={<PageMemberLicense />} />
      <Route
        path="/memberlicense/assignmemberlicense"
        element={<PageAssignMemberLicense />}
      />
      <Route path="/version/internal" element={<PageInternalVersion />} />
      <Route path="/version/public" element={<PagePublicVersion />} />

      <Route path="/support/ticket/:ticketid" element={<PageTicketSupport />} />
      <Route path="/support" element={<PageSupport />} />
      <Route
        path="/supportremoteaccess/:ticketid"
        element={<PageSupportRemoteAccess />}
      />
      <Route
        path="/designstudioremoteaccess"
        element={<PageDesignStudioRemoteAccess />}
      />

      <Route path="/distributor" element={<PageDistributor />} />
      <Route path="/distributor/Knowledge" element={<PageKnowledge />} />
      <Route path="/distributor/Video" element={<PageVideo />} />
      <Route
        path="/distributor/UpcomingEvents"
        element={<PageUpcomingEvents />}
      />
      <Route path="/distributor/WhatsNew" element={<PageWhatsNew />} />

      <Route path="/subscriptions" element={<PageSubscriptions />} />
      <Route path="/marketspace" element={<PageMarketSpace />} />
      <Route path="/marketspaceform" element={<PageMarketSpaceForm />} />
      <Route
        path="/marketspaceformedit"
        element={<PageMarketSpaceFormEdit />}
      />

      <Route
        path="/marketspacedownload"
        element={<PageMarketSpaceDownload />}
      />
      <Route path="/subscriptionplan" element={<PageSubscriptionsPlan />} />
      <Route path="/role" element={<PageRole />} />
      <Route path="/ota" element={<PageOta />} />
      <Route path="/ota-beta" element={<PageOtaBeta />} />
      <Route path="/ota-crash-logs" element={<PageOtaCrashLogsList />} />
      <Route path="/user" element={<PageUser />} />
      <Route
        path="/OkasAdditionalInventoryRequest"
        element={<PageOkasAdditionalInventoryRequest />}
      />

      {/* Catch-all route for 404 Page */}
      <Route path="*" element={<PagePageNotFound />} />
    </Routes>
  </Router>
);

export default AppRouter;
